export default __webpack_public_path__ + "static/media/checkbox-checked_grey@2x.8c361816.png";